<template>
  <form method="post" @submit.prevent="submitForm">
  <table class="table table-borderless">
    <tbody>
      <tr
      v-for="(item, index) in poitems"
      :key="index"
      class="bg-gray-light mb-5 border-bottom">
        <td>
          <!-- <label class="">Purchase Order Item Name: </label> -->
          <input
          type="text"
          name="ItemName"
          class="form-control is-valid"
          v-model="item.ItemName"
          readonly
          />
          <span class="badge badge-danger">
            Remaining Quantity - {{ item.RemainingQuantity }}
          </span>
          <span class="badge badge-success">
            Received Quantity - {{ item.ReceivedQuantity }}
          </span>
          <span class="badge badge-info">
            Ordered Quantity - {{ item.Quantity }}
          </span>
            <span class="badge badge-warning text-white">
                Rejected Quantity - {{ item.RejectedQuantity }}
            </span>
          <delivery-challan-item-edit-batch
          :item-id="item.Id"
          ref="dcItemEditBatches"
          ></delivery-challan-item-edit-batch>
        </td>
      </tr>
      <tr>
        <td class="text-right">
          <!-- <button
            class="mt-5 btn btn-info"
            data-toggle="tooltip"
            data-placement="top"
            title="Add New Item"
          >
            Add new item
          </button> -->
          <button type="submit"
           class="mt-5 btn btn-success">Save</button>
        </td>
      </tr>
    </tbody>
  </table>
</form>
</template>

<script>
import DeliveryChallanEditItem from './DeliveryChallanItemEditBatch'
export default {
  name: "delivery-challan-edit-item",
  props: ['deliveryChallanId'],
  components: {
      'delivery-challan-item-edit-batch' : DeliveryChallanEditItem,
  },
  data() {
    return {
        poitems: null,
        formData: null
    };
  },
  methods: {
    getPurchaseOrderItems() {
      axios
        .get("delivery-challan/items/edit/" + this.deliveryChallanId)
        .then((response) => {
          this.poitems = response.data.data;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    submitForm() {
        var allBatches = this.$refs.dcItemEditBatches
        console.log(allBatches);
        var singleBatch = [];
        this.poitems.forEach(function (item, index) {
            singleBatch.push(allBatches[index].data)
        });
        this.formData = {
            DeliveryChallanId : this.deliveryChallanId,
            data : singleBatch
        }
        this.postDeliveryChallanEditItems()
    },
    postDeliveryChallanEditItems() {
        axios.post('delivery-challan/items/update', this.formData)
            .then(response => {
                Swal.fire({
                        title: 'Updated Successfully',
                        icon: 'success',
                        })
            }).catch(error => {
            this.errored = true
        })
            .finally(() => this.loading = false)
    },
  },
  mounted () {
      this.getPurchaseOrderItems();
  },
};
</script>

<style lang="scss" scoped>
</style>
